import { config } from '@iheartjane/config';

import { googleMapsLoader } from './loader';

export const getGoogleMaps = () => googleMapsLoader(config.googlePlacesKey);
